export default __webpack_public_path__ + "static/media/CV_ENGLISH.b639879f.pdf";